/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=1d58b19b&lang=scss"
import "./App.vue?vue&type=style&index=1&id=1d58b19b&lang=scss"

const __exports__ = script;

export default __exports__